(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PrestadoresPorDependenciaProyectoController', PrestadoresPorDependenciaProyectoController);

    PrestadoresPorDependenciaProyectoController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function PrestadoresPorDependenciaProyectoController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        sSAmbitos.$promise.then(function(sSAmbitos) {
        	vm.sSAmbitos = sSAmbitos;
            vm.selectedSSAmbito = sSAmbitos[0];
        });

        vm.centrosDocentes = centrosDocentes;
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.prestadoresPorDependenciaProyecto(
                    vm.selectedSSPeriodo.id,
                    vm.selectedSSAmbito
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();
